import React from "react";
import Cat6aImg from '../../../../assets/images/cat6a.jpg';


import './styles.css';
import "font-awesome/css/font-awesome.min.css";

const Cat6 = () => {

    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>Título</h1>
                </div>
                <div className="col-sm-12">
                    <div className="siglas">
                        <img src={Cat6aImg} alt="siglas" />
                    </div>
                </div>                
            </div>
        </div>
    );
};
export default Cat6;